/**
 * Tags completion status for faces/clusters
 * Used to indicate the state of required tags filling
 */
const TagsCompletionStatus = {
    EMPTY: 'empty',       // No required tags filled
    PARTIAL: 'partial',   // Some required tags filled
    COMPLETE: 'complete'  // All required tags filled
}

export default TagsCompletionStatus
